/**
 * `POST /auth/login` and its second step (uiv2 BE7). A 401 there refuses a
 * sign-in attempt — the page shows it — and is never an expired session to
 * refresh (AuthContext's interceptor). URLs arrive relative to the /api base.
 */
export function isSignInRequest(url: string | undefined): boolean {
  return !!url && /^\/?auth\/login(\/|$|\?)/.test(url.replace(/^\/api/, ''));
}
